import { useState } from "react";
import { Typography, Box } from "@mui/material";
import {
  parseAnchor,
  boldColonHeadings,
  isLinkClicked,
  markLinkClicked,
} from "../../../../utils/functions";
import {
  BODY_SPACING,
  SPACING,
} from "../../../../utils/constants/designConstants";

export const FinancialReports = ({ financialReports }) => {
  const [clickedLinks, setClickedLinks] = useState(new Set());
  if (!financialReports || financialReports.length === 0) {
    return (
      <Typography
        variant="body2"
        sx={{
          color: "primary.white",
          py: BODY_SPACING.ERROR_MESSAGE_SECTION_PADDING,
          mt: BODY_SPACING.ERROR_MESSAGE_SECTION_MARGIN_TOP,
          mb: BODY_SPACING.ERROR_MESSAGE_SECTION_MARGIN_BOTTOM,
        }}
      >
        Financial reports aren't available at the moment.
      </Typography>
    );
  }
  try {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: SPACING.SECTION_GAP,
        }}
      >
        {financialReports.map((item, index) => {
          try {
            const parsedTitle = parseAnchor(item?.Title);
            const displayTitle = item.title || parsedTitle?.text || "Untitled Report";
            const titleHref = item.url || parsedTitle?.href || undefined;
            const supplierName = item.supplier_name || item["Supplier Name"] || "N/A";
            const summary = item.summary || item.Summary || "-";

            return (
              <Box
                key={index}
                component="section"
                aria-labelledby={`financial-report-${index}-heading`}
                sx={{ mb: SPACING.CONTENT_GAP }}
              >
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: SPACING.CONTENT_GAP }}
                >
                  {/* Title */}
                  <Typography
                    variant="h4"
                    component={titleHref ? "a" : "h3"}
                    href={titleHref}
                    target={titleHref ? "_blank" : undefined}
                    rel={titleHref ? "noopener noreferrer" : undefined}
                    onClick={
                      titleHref
                        ? () => markLinkClicked(titleHref, clickedLinks, setClickedLinks)
                        : undefined
                    }
                    sx={{
                      textDecoration: "none",
                      color: isLinkClicked(titleHref, clickedLinks)
                        ? "secondary.berry"
                        : "secondary.tiffanyBlue",
                      mb: SPACING.CONTENT_GAP,
                    }}
                  >
                    {displayTitle}
                  </Typography>

                  {/* Supplier Name */}
                  <Box>
                    <Typography
                      variant="subtitle1"
                      sx={{ mb: SPACING.SUBTITLE_MARGIN }}
                    >
                      Supplier Name:
                    </Typography>
                    <Typography variant="body1">{supplierName}</Typography>
                  </Box>

                  {/* Summary */}
                  {summary && (
                    <Box>
                      <Typography
                        variant="subtitle1"
                        sx={{ mb: SPACING.SUBTITLE_MARGIN }}
                      >
                        Summary:
                      </Typography>

                      <Box>
                        {summary.split("\n\n").map((paragraph, pIndex) => (
                          <Box key={pIndex} sx={{ mb: SPACING.PARAGRAPH_MARGIN }}>
                            {boldColonHeadings(paragraph)}
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>
            );
          } catch (error) {
            console.error(`Error rendering financial report ${index}:`, error);
            return (
              <Typography
                key={index}
                variant="body2"
                color="error"
                sx={{ py: BODY_SPACING.ERROR_MESSAGE_SECTION_PADDING }}
              >
                Sorry, we couldn’t display this report at the moment.
              </Typography>
            );
          }
        })}
      </Box>
    );
  } catch (error) {
    console.error("Error rendering financial reports:", error);
    return (
      <Typography
        variant="body2"
        color="error"
        sx={{ py: BODY_SPACING.ERROR_MESSAGE_SECTION_PADDING }}
      >
        Sorry, we couldn’t display this reports at the moment. Please try again
        later.
      </Typography>
    );
  }
};
